import { gql } from '@apollo/client';

export const UPDATE_DRAFT_CATEGORIES_MUTATION = gql`
    mutation updateDraftCategories($input: UpdateCategoriesInput) {
        updateDraftCategories(input: $input) {
            status
            categories
            textBlocks {
                id
                type
                data {
                    paragraph
                    header
                    level
                    items {
                        id
                        text
                    }
                    file {
                        url
                    }
                    code
                    withBorder
                    withBackground
                    stretched
                    caption
                    style
                }
            }
            textBlocksVersions {
                blocks {
                    id
                    type
                    data {
                        paragraph
                        header
                        level
                        items {
                            id
                            text
                        }
                        file {
                            url
                        }
                        code
                        withBorder
                        withBackground
                        stretched
                        caption
                        style
                    }
                }
                id
            }
            createdAt
            updatedAt
            id
        }
    }
`;
